<!-- src/views/Unauthorized.vue -->
<template>
  <div>
    <h1>Access Denied</h1>
    <p>You are not authorized to access this application.</p>
    <button @click="retryLogin">Try Again</button>
  </div>
</template>

<script>
import authService from '@/services/auth';

export default {
  name: 'UnauthorizedPage',
  methods: {
    retryLogin() {
      authService.signIn();
    },
  },
};
</script>
